import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useRef } from '@uppy/core/utils/preact/hooks';
import classNames from 'classnames';
import ignoreEvent from '../utils/ignoreEvent.js';
function PickerPanelContent({ activePickerPanel, className, hideAllPanels, i18n, state, uppy, }) {
    const ref = useRef(null);
    const activePlugin = uppy.getPlugin(activePickerPanel.id);
    // A picker's panel ignores dropped files: they would not end up where it
    // shows (a Google Drive folder, say). A plugin can opt in with
    // `acceptsFileDrops` (a storage browser); then the Dashboard takes a drag of
    // files as it would anywhere else. Not a drag of text or links, nor one over
    // a text field or an open dialog.
    const leaveToDashboard = (event) => {
        const target = event.target;
        return (Boolean(activePlugin?.acceptsFileDrops) &&
            Boolean(event.dataTransfer?.types.includes('Files')) &&
            target.closest('input, textarea, dialog') == null);
    };
    const ignoreDrag = (event) => {
        if (leaveToDashboard(event))
            return;
        ignoreEvent(event);
        // Where that blocked the drop (anywhere but a text field), don't show the
        // copy cursor that promises one.
        if (event.type === 'dragover' &&
            event.defaultPrevented &&
            event.dataTransfer)
            event.dataTransfer.dropEffect = 'none';
    };
    return (_jsxs("div", { className: classNames('uppy-DashboardContent-panel', className), role: "tabpanel", "data-uppy-panelType": "PickerPanel", id: `uppy-DashboardContent-panel--${activePickerPanel.id}`, onDragOver: ignoreDrag, onDragLeave: ignoreDrag, onDrop: ignoreDrag, onPaste: ignoreEvent, children: [_jsxs("div", { className: "uppy-DashboardContent-bar", children: [_jsx("div", { className: "uppy-DashboardContent-title", role: "heading", "aria-level": 1, children: i18n('importFrom', { name: activePickerPanel.name }) }), _jsx("button", { className: "uppy-DashboardContent-back", type: "button", onClick: hideAllPanels, children: i18n('cancel') })] }), _jsx("div", { ref: ref, className: "uppy-DashboardContent-panelBody", children: activePlugin?.render(state, ref.current) })] }));
}
export default PickerPanelContent;
